const plugin = {
    beforeDraw: function (chartInstance) {
        const ctx = chartInstance.chart.ctx;
        /* 
            * This is the place where we can define what the background color should be - in this instance we want it to be white to match the background 
        */
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
    }
};

export default plugin;